/** The /about page: who the shop is, where, how it delivers and takes returns. Copy lives in src/shop-about.ts (shared with the server-rendered page). */
import { useEffect } from "react";
import { aboutSections } from "../../../src/shop-about";
import { resolveContact } from "../../../src/shop-contact";
import { Go, type GoFn } from "./route";
import { setSeo } from "./seo";
import type { ShopConfig } from "./types";

export function AboutPage({ config, go }: { config: ShopConfig | null; go: GoFn }) {
  const sections = aboutSections(resolveContact(config));
  useEffect(() => {
    setSeo("About us", "About Z S MERCH: who we are, where to collect, delivery, payment, returns and wholesale accounts.");
  }, []);
  return (
    <div className="wrap page-pad">
      <nav className="crumbs" aria-label="Breadcrumb"><ol><li><Go to={{ name: "home" }} go={go}>Home</Go></li><li aria-current="page">About us</li></ol></nav>
      <h1>About Z S MERCH</h1>
      {sections.map((s) => (
        <section key={s.title}>
          <h2>{s.title}</h2>
          {s.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
        </section>
      ))}
      <p><Go to={{ name: "faq" }} go={go}>Read the full FAQ</Go> · <Go to={{ name: "contact" }} go={go}>Contact us</Go></p>
    </div>
  );
}
